<app-custom-button
  [icon]="'developer_mode'"
  [tooltip]="'Show original resources'"
  (buttonClick)="openModal()"
></app-custom-button>
